import { Site } from '@services/site';
import { Type } from 'class-transformer';
import { ParkingAreaInfrastructure } from './parking-area-infrastructure.class';

export class SiteInfrastructure {
	site: Site;
	infrastructureCost: number;
	infrastructureCostPerEvCar: number;

	@Type(() => ParkingAreaInfrastructure)
	parkingAreaInfrastructure: ParkingAreaInfrastructure[];
}
